import { store } from "@/stores/stores"
import { useSnapshot } from "valtio"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { Link } from "react-router"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import LogoSvg from "@/assets/images/logo-short.svg?react"
import LogoKinboxSvg from "@/assets/images/logo-kinbox-short.svg?react"
import { kinboxUrl } from "@/App"
const iconClassname = "bg-[#1868db] fc rounded-lg [&_path]:!text-white [&_path]:!fill-white [&_svg]:!size-5 size-8"

function AppChangerMenu() {
  const snap = useSnapshot(store)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className={cn("size-10 rounded-full text-fg-secondary")} variant="ghost" size="icon">
          <IconMaterialSymbolsApps className="size-6" />
        </Button>
      </DropdownMenuTrigger>
      {/* <DropdownMenuContent className="w-95 p-0"> */}
      <DropdownMenuContent className="w-[250px] py-4">
        <label className="ml-3 text-[11px] font-semibold">YOUR APPS</label>
        <a href={kinboxUrl}>
          <DropdownMenuItem>
            <span className={iconClassname}>
              <LogoKinboxSvg />
            </span>
            Kinbox
          </DropdownMenuItem>
        </a>
        <a href={window.location.origin}>
          <DropdownMenuItem>
            <span className={iconClassname}>
              <LogoSvg />
            </span>
            Hado
          </DropdownMenuItem>
        </a>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default AppChangerMenu
